export default __webpack_public_path__ + "static/media/angleon.6486d7d4.png";